
@if (this.folderService?.breadCrumbsList.length > 1) {
  <div class='shareBreadcrumb desktopFolderBreadCrumb' [ngClass]="[(!universalService.isMobileDevice && universalService.currentTab == 'sharedFiles') ? 'folder-path-sharedFiles' : 'folder-path' , (universalService.iframeLogin ? 'cloud-pc-folder-path' : '') ]">
    <div class='breaddCrumb_DropDown'>
      @if (this.folderService.breadCrumbsList.length > 1) {
        <div class='rootFolderName'
          (click)="this.navigateBreadCrumb(this.globalService.getFolderServiceRef().breadCrumbsList[0].objectKey)"
          title='{{this.globalService.getFolderServiceRef().breadCrumbsList[0].objectName}}'>
          <a href='javascript:void(0);' rel="noopener noreferrer">{{this.globalService.getFolderServiceRef().breadCrumbsList[0].objectName}}</a>
        </div>
      }
      @if (this.globalService.getFolderServiceRef().breadCrumbsList.length > 3) {
        <div class='parentFolderName '>
          <i> &nbsp;/ </i>
          <span (click)="openDropDown()" style="color: #0078ad; cursor: pointer;"> ... </span>
          @if (this.dropdownlist.length > 0) {
            <div class="dropdown">
              <ul>
                @for (dpfolder of dropdownlist; track dpfolder) {
                  <li (click)="this.navigateBreadCrumb(dpfolder.objectKey)">
                    <span class="NeueFolderFilled"></span>
                    {{dpfolder.objectName}}
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      }
      <div class='parentFolderName' (click)="this.navigateBreadCrumb(this.globalService.getFolderServiceRef().parentFolderKey)"
        title='{{this.globalService.getFolderServiceRef().parentFolderName}}'>
        @if (this.globalService.getFolderServiceRef().breadCrumbsList.length > 2 && this.globalService.getFolderServiceRef().parentFolderName!='') {
          <i> &nbsp;/ </i>
        }
        @if (this.globalService.getFolderServiceRef().breadCrumbsList.length > 2) {
          <a
          href='javascript:void(0);' rel="noopener noreferrer">{{this.globalService.getFolderServiceRef().parentFolderName}} </a>
        }
      </div>
      <div class='currentFolderName' title='{{this.globalService.getFolderServiceRef().currentFolderName}}'>
        <i class=""> &nbsp;/ </i>{{this.globalService.getFolderServiceRef().currentFolderName}}
      </div>
    </div>
  </div>
}